//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { uid } from "quasar";
import draggable from "vuedraggable";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import setConditions from "@/components/Diagrams/config/set-conditions.vue";
import ruleOutcomes from "@/components/Diagrams/config/subcomponents/rule-outcomes.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import { deepCopy } from "./set-conditions";

export default {
    components: {
        AQModal,
        setConditions,
        AQInput,
        ruleOutcomes,
        draggable,
        AQButton,
        AQDialog,
        AQCard
    },
    props: {
        uuid: {
            type: String,
            default: ""
        },
        elementIndex: {
            type: Number,
            default: 0
        },
        value: {
            type: null,
            default: null
        },
        hideOutcomes: {
            type: Object,
            default() {
                return {
                    taskSubject: false,
                    instanceName: false,
                    taskPriority: false,
                    deadline: false,
                    targets: false,
                    notifications: false,
                    ifExpires: true,
                    continueIfRejected: true
                };
            }
        },
        hideInitialValues: {
            type: Object,
            default() {
                return {
                    users: false,
                    taskDetails: false
                };
            }
        },
        title: {
            type: String,
            default: ""
        },
        readonly: {
            type: Boolean
        },
        approvalFields: Boolean,
        currentLevelDetails: {
            type: Object,
            default: () => {}
        },
        fromLevel: {
            type: Boolean
        },
        fromConnector: {
            type: Boolean
        }
    },
    data() {
        return {
            changeSize: false,
            initialRule: null,
            initialConditions: {},
            tempRule: {},
            initialRulesData: [],
            modalOpened: false,
            saveEnabled: false,
            rulesDefined: false,
            hasClose: true,
            rule: null,
            drag: false,
            warningDlg: false,
            hasError: false,
            warningUpdateDlg: false,
            headerActionsModel: [
                {
                    value: "deleteRule",
                    label: this.$t("diagrams.components.setRules.delete")
                }
            ]
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData"]),
        ...mapGetters("rules", [
            "getCurrentRule",
            "getCurrentLevel",
            "getBackToDiagram"
        ]),
        hasPrimary() {
            return {
                label: this.$t("generic.done"),
                disabled: this.readonly || this.hasError
            };
        },
        setHeaderActions() {
            return this.readonly || !this.showHeaderActions ? [] : this.headerActionsModel;
        },
        returnTitle() {
            return (
                this.title
                || `${this.elementIndex
                    + 1
                }.${
                    this.selectedPluginConfigData.label
                }/${
                    this.$t("diagrams.components.setRules.ruleEditor")}`
            );
        },
        rules() {
            return this.value ? JSON.parse(JSON.stringify(this.value)) : [];
        },
        showTestAllRulesBtn() {
            let showBtn = false;
            if (
                !Object.entries(this.getCurrentLevel).length
                && this.selectedPluginConfigData.rules
                && this.selectedPluginConfigData.rules.length
                && !this.fromConnector
            ) {
                showBtn = true;
            }
            return showBtn;
        },
        rulesPreview: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit(
                    "input",
                    v.map((rule, index) => ({ ...rule, index: index + 1 }))
                );
            }
        },
        showHeaderActions() {
            return this.rule.index !== this.rules.length;
        },
        hasTest() {
            return !(this.readonly || this.fromConnector) ? { label: this.$t("generic.test"), disabled: this.hasError } : null;
        }
    },
    watch: {
        getBackToDiagram: {
            handler(newValue) {
                if (newValue && Object.entries(this.getCurrentRule).length) {
                    this.rule = { ...this.getCurrentRule };
                    if (!this.initialRule) {
                        this.initialRule = deepCopy(this.getCurrentRule).clone;
                    }
                    this.modalOpened = true;
                    this.$store.commit("rules/setBackToDiagram", false);
                    const isUpdate = this.rules.find(
                        el => el.uuid === this.rule.uuid
                    );
                    if (isUpdate && this.initialRulesData.length) {
                        for (let i = 0; i < this.initialRulesData.length; i++) {
                            if (
                                this.initialRulesData[i].uuid === this.rule.uuid
                            ) {
                                this.saveEnabled = JSON.stringify(this.initialRulesData[i])
                                    !== JSON.stringify(this.rule);
                            } else {
                                this.saveEnabled = true;
                            }
                        }
                    } else {
                        this.saveEnabled = true;
                    }
                }
            },
            immediate: true
        }
    },
    validations: {
        rule: {
            name: {
                required
            },
            conditions: {
                required(v) {
                    return v && v.conditions.length;
                }
            },
            outcomes: {
                notifications: {
                    required(v) {
                        return !!v.length;
                    }
                },
                targets: {
                    required(v) {
                        let valid = true;
                        let hasApprover = !this.approvalFields;
                        let i;

                        for (i = 0; i < v.length; i++) {
                            if (!v[i].to) {
                                valid = false;
                            } else {
                                valid = !!(
                                    (v[i].to.user && v[i].to.user.length)
                                    || (v[i].to.role && v[i].to.role.length)
                                    || (v[i].to.model && v[i].to.model.length)
                                    || (v[i].to.variable
                                        && v[i].to.variable.length)
                                    || (v[i].to.freeText
                                        && v[i].to.freeText.length)
                                    || (v[i].to.dataTextList
                                        && v[i].to.dataTextList.length)
                                );
                            }

                            if (!valid) {
                                break;
                            }

                            if (this.approvalFields && !hasApprover) {
                                hasApprover = v[i].right === "appr";
                            }
                        }

                        return valid && hasApprover;
                    }
                },
                taskPriority: {
                    required(v) {
                        return !!(v && v.length);
                    }
                },
                taskSubject: {
                    required(v) {
                        return !!(v && v.length);
                    }
                },
                instanceName: {
                    required(v) {
                        return !!(v && v.length);
                    }
                },
                deadline: {
                    required(v) {
                        return !!(v && v.deadline);
                    }
                },
                ifExpires: {
                    required(v) {
                        return !!(
                            !this.hideOutcomes.ifExpires
                            && v
                            && v.deadline
                        );
                    }
                }
            }
        }
    },
    deactivated() {
        this.$store.commit("rules/setCurrentRule", {});
    },
    methods: {
        setInitialRules() {
            this.initialRulesData = this.value ? JSON.parse(JSON.stringify(this.value)) : [];
        },
        changeSizeModal(value) {
            this.changeSize = value;
        },
        okWarningUpdateDlg() {
            this.initialRulesData.forEach(rule => {
                if (rule.uuid === this.initialRule.uuid) {
                    rule.conditions.conditions = this.initialRule.conditions.conditions;
                    rule.conditions.statement = this.initialRule.conditions.statement;
                    rule.outcomes = this.initialRule.outcomes;
                }
            });
            this.$store.commit("rules/setCurrentRule", {});
            this.$emit("input", this.initialRulesData);
            this.hide();
        },
        enableSave() {
            this.saveEnabled = this.$v.rule.conditions.required && !this.$v.rule.name.$error;
        },
        action(action) {
            const vm = this;
            if (action === "primary") {
                this.modalActionSave();
            } else if (action === this.$t("diagrams.components.setRules.delete")) {
                this.$store.commit("rules/setCurrentRule", {});
                const indexToDelete = this.rules.findIndex(el => el.uuid === this.rule.uuid);
                this.rules.splice(indexToDelete, 1);
                for (let i = 0; i < this.rules.length; i++) {
                    this.rules[i].index = i;
                }
                this.rulesDefined = true;
                this.$emit("rulesDefined", this.rulesDefined);
                this.$emit("input", this.rules);
                this.hide();
            } else if (action === "secondary") {
                this.modalActionSave(true);
            } else if (action === "close") {
                const currentRules = vm.rules;
                const isUpdate = currentRules.find(
                    el => el.uuid === vm.rule.uuid
                );
                if (!this.fromLevel && vm.rule.outcomes.ifExpires) {
                    vm.rule.outcomes.ifExpires = "";
                }

                if (isUpdate) {
                    if (this.initialRulesData.length === currentRules.length) {
                        for (let i = 0; i < this.initialRulesData.length; i++) {
                            if (
                                this.initialRulesData[i].uuid === vm.rule.uuid
                            ) {
                                if (!this.fromLevel) {
                                    this.checkForDeadline(this.initialRulesData[i], vm.rule);
                                }
                                if (
                                    JSON.stringify(this.initialRulesData[i])
                                    !== JSON.stringify(vm.rule)
                                ) {
                                    this.warningUpdateDlg = true;
                                } else {
                                    this.$store.commit(
                                        "rules/setCurrentRule",
                                        {}
                                    );
                                    this.hide();
                                }
                            }
                        }
                    } else {
                        this.warningUpdateDlg = true;
                    }
                } else {
                    if (this.fromLevel) {
                        this.tempRule = {
                            uuid: vm.rule.uuid,
                            name: "",
                            description: "",
                            conditions: {
                                statement: "",
                                conditions: []
                            },
                            computedCondition: "",
                            outcomes: {
                                targets: [
                                    {
                                        to: {},
                                        task: 1,
                                        prolonger: false,
                                        right: "appr",
                                        approvalThreshold: null,
                                        hasError: false,
                                        badgeType: {
                                            value: "txt",
                                            button: "txt"
                                        },
                                        decisionTypeDdl: [
                                            {
                                                value: "singular",
                                                label: "Singular",
                                                tooltipProps: {
                                                    tooltipContent: this.$t("diagrams.components.ruleOutcomes.singularTooltip")
                                                }
                                            }
                                        ]
                                    }
                                ],
                                notifications: [],
                                taskPriority: "lowest",
                                continueIfRejected: false,
                                ifExpires: "AR",
                                approvalTime: {
                                    days: 2,
                                    hours: 12,
                                    minutes: 0
                                }
                            },
                            index: this.rules.length
                        };
                    } else {
                        this.tempRule = {
                            uuid: vm.rule.uuid,
                            name: "",
                            description: "",
                            conditions: {
                                statement: "",
                                conditions: []
                            },
                            computedCondition: "",
                            outcomes: {
                                targets: [
                                    {
                                        to: {},
                                        task: 1,
                                        prolonger: false,
                                        right: "eval"
                                    }
                                ],
                                notifications: [],
                                taskPriority: "normal",
                                continueIfRejected: false,
                                ifExpires: "",
                                approvalTime: {
                                    approvalTime: null,
                                    timeUnit: null
                                }
                            },
                            index: this.rules.length
                        };
                        if (this.currentLevelDetails) {
                            this.tempRule.outcomes.targets = [];
                        }
                    }
                    if (JSON.stringify(this.tempRule) !== JSON.stringify(vm.rule)) {
                        this.warningDlg = true;
                    } else {
                        this.$store.commit("rules/setCurrentRule", {});
                        this.hide();
                    }
                }
            }
        },
        okWarningDlg() {
            this.$store.commit("rules/setCurrentRule", {});
            this.hide();
        },
        modalActionSave(fromTest) {
            const { ruleOutcomesRef } = this.$refs;
            const dedlineRef = ruleOutcomesRef && ruleOutcomesRef.$refs.deadlineRuleRef ? ruleOutcomesRef.$refs.deadlineRuleRef : null;
            if (dedlineRef) {
                dedlineRef.$v.$touch();
            }

            if (!fromTest) {
                this.$store.commit("rules/setCurrentRule", {});
            }
            this.$v.rule.name.$touch();
            this.$v.rule.outcomes.$touch();
            if (this.$v.rule.name.$error) {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("diagrams.components.setRules.ruleNameRequired")
                });
                return false;
            }
            if (!this.$v.rule.conditions.required) {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("diagrams.components.setRules.conditionsRequired")
                });
                return false;
            }

            if (this.approvalFields && this.$v.rule.outcomes.targets.$error) {
                const targetsAndRights = this.$t("diagrams.components.setRules.targetsAndRightRequired");
                const targetsRequired = this.$t("diagrams.components.setRules.targetsRequired");
                this.$toast.showNotify({
                    type: "error",
                    message: this.approvalFields ? targetsAndRights : targetsRequired
                });
                return false;
            }
            if (dedlineRef && dedlineRef.$v.$error) {
                return false;
            }

            if (
                this.fromConnector
                && this.$v.rule.outcomes.notifications.$error
            ) {
                this.$toast.showNotify({
                    type: "warning",
                    message: this.$t("diagrams.components.setRules.outcomesRequired")
                });
                return false;
            }

            if (
                this.$v.rule.outcomes.notifications.$error
                && this.$v.rule.outcomes.targets.$error
                && !this.approvalFields
                && this.$v.rule.outcomes.taskPriority.$error
                && this.$v.rule.outcomes.taskSubject.$error
                && this.$v.rule.outcomes.instanceName.$error
                && this.$v.rule.outcomes.deadline.$error
                && this.$v.rule.outcomes.ifExpires.$error
            ) {
                this.$toast.showNotify({
                    type: "warning",
                    message: this.$t("diagrams.components.setRules.outcomesRequired")
                });
                return false;
            }

            const currentRules = this.rules;

            let isNewRule = true;
            if (!this.fromLevel && this.rule.outcomes.ifExpires) {
                this.rule.outcomes.ifExpires = "";
            }

            for (let i = 0; i < currentRules.length; i++) {
                if (currentRules[i].uuid === this.rule.uuid) {
                    currentRules[i] = this.rule;

                    isNewRule = false;

                    break;
                }
            }

            if (isNewRule) {
                currentRules.push(this.rule);
            }
            if (fromTest && currentRules && currentRules.length) {
                currentRules.forEach(rule => {
                    if (rule.uuid === this.getCurrentRule.uuid) {
                        this.$store.commit("rules/setCurrentRule", rule);
                    }
                });

                const isUpdate = currentRules.find(
                    el => el.uuid === this.rule.uuid
                );
                if (isUpdate) {
                    if (this.initialRulesData.length === currentRules.length) {
                        for (let i = 0; i < this.initialRulesData.length; i++) {
                            if (
                                this.initialRulesData[i].uuid === this.rule.uuid
                            ) {
                                if (
                                    JSON.stringify(this.initialRulesData[i])
                                    !== JSON.stringify(this.rule)
                                ) {
                                    this.$store.commit(
                                        "main/setInterfaceDirty",
                                        true
                                    );
                                }
                            }
                        }
                    } else {
                        this.$store.commit("main/setInterfaceDirty", true);
                    }
                } else {
                    this.$store.commit("main/setInterfaceDirty", true);
                }

                this.$store.commit("rules/setShowRuleTesting", true);
            }
            if (!fromTest) {
                this.$emit("input", currentRules);
                this.rulesDefined = true;
                this.$emit("rulesDefined", this.rulesDefined);
            }

            this.hide();
            return false;
        },
        hide() {
            this.$v.$reset();
            this.modalOpened = false;
            this.saveEnabled = false;
        },

        addNewRule() {
            const newRule = {
                uuid: uid(),
                name: "",
                description: "",
                conditions: {
                    statement: "",
                    conditions: []
                },
                computedCondition: "",
                outcomes: {
                    notifications: [],
                    targets: [
                        {
                            to: {},
                            task: 1,
                            prolonger: false,
                            right: "eval"
                        }
                    ]
                },
                index: this.rules.length
            };
            if (this.currentLevelDetails) {
                newRule.outcomes.targets = [];
                this.$store.commit(
                    "rules/setCurrentLevel",
                    this.currentLevelDetails
                );
            }
            this.rule = newRule;
            this.saveEnabled = false;
            this.$store.commit("rules/setCurrentRule", newRule);
            this.modalOpened = true;
        },
        editRule(ruleInfo) {
            this.$store.commit("rules/setCurrentRule", ruleInfo);
            this.rule = { ...ruleInfo };
            this.initialRule = deepCopy(ruleInfo).clone;
            this.saveEnabled = false;
            this.modalOpened = true;
        },
        openRuleTesting() {
            this.$store.commit("rules/setShowRuleTesting", true);
            this.$store.commit("rules/setTestAllRules", true);
        },
        afterCloseModal() {
            this.modalOpened = false;
        },
        checkForDeadline(initialData, currentData) {
            const defaultDeadline = {
                days: 0,
                deadlineAttribute: "s_Task.creationDateTime",
                hours: 0,
                minutes: 0
            };
            if (!initialData.outcomes.deadline && currentData.outcomes.deadline
                && JSON.stringify(currentData.outcomes.deadline) === JSON.stringify(defaultDeadline)) {
                currentData.outcomes.deadline = undefined;
            }
        },
        onApprovalsError(hasError) {
            this.hasError = hasError;
        }
    }
};
